import script from "./UserApproveReferral.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserApproveReferral.vue?vue&type=script&setup=true&lang=ts"

import "./UserApproveReferral.vue?vue&type=style&index=0&id=c5eb0304&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5eb0304"]])

export default __exports__